import axios from "axios";
import {
  setToken,
  getToken,
  removeToken,
  getUrl,
  setUrl,
  removeUrl,
  setphonenum,
  getphonenum
} from "@/common/cook";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import Vue from "vue";
const service = axios.create({
  // baseURL: 'https://bk.zhuoyuyun.com/', // 正式环境
  //baseURL: "https://www.zhuoyuyun.com/", // 正式环境
  baseURL: "https://www.zhuoyuyun.com/", // 本地环境
  // baseURL: "http://127.0.0.1:8082",
  // baseURL: "/api/", // 正式环境
  timeout: 20000000 // request timeout
});
// console.log(process.env.VUE_APP_BASE_API)
// request interceptor
service.interceptors.request.use(
  config => {
    config.headers.post["Content-Type"] = "application/json";
    if (getToken()) {
      config.headers["token"] = getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
// params -- get
// data -- post
// response interceptor
service.interceptors.response.use(
  response => {
    let { data, status } = response;
    const newres = {
      status: status
    };
    const res = Object.assign(data, newres);
    // if(res.code==40004){
    // 	Message({
    // 		type:'warning',
    // 		message:'登录失效'
    // 	})
    // 	window.localStorage.clear()
    // }
    //10001 正确
    //40001 错误
    //10001 正确
    //40004 登录时效
    if (res.code !== 200) {
      if (res.code == 10001) {
        return res;
      } else {
        return res;
      }
    } else {
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 700
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/common/http.js